<template>
  <el-container
    class="container-list is-vertical webpage-content-editor"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <div style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;">
          <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
            <el-breadcrumb-item>網頁設計</el-breadcrumb-item>
            <el-breadcrumb-item>隱私權政策</el-breadcrumb-item>
            <el-breadcrumb-item>內文</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
      <template slot="right">
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main style="padding-top: 50px !important;">

        <el-tabs v-model="activeLang" type="card">
          <el-tab-pane label="繁中" name="Tw">
            <c-k-editor-form ref="form-Tw" @input="onInput" :value="this.webInfos[this.webInfoIDs[0]].Value"></c-k-editor-form>
          </el-tab-pane>
          <!-- <el-tab-pane v-if="languages.includes('Cn')" label="簡中" name="Cn"></el-tab-pane> -->
          <el-tab-pane v-if="languages.includes('En')" label="英文" name="En">
            <c-k-editor-form ref="form-En" @input="onInput" :value="this.webInfos[this.webInfoIDs[1]].Value"></c-k-editor-form>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('Jp')" label="日文" name="Jp">
            <c-k-editor-form ref="form-Jp" @input="onInput" :value="this.webInfos[this.webInfoIDs[2]].Value"></c-k-editor-form>
          </el-tab-pane>
        </el-tabs>

        <el-button :disabled="!isUpdated" class="btn-upload" style="top: 12px;" type="primary" size="mini" @click="submit">送出<i class="el-icon-upload el-icon--right"></i></el-button>

      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import CKEditorForm from './form-ckeditor'
// svgs
import '@/assets/svgs/index.js'
import MixinLanguages from '@/utils/mixin-languages.vue'
export default {
  mixins: [MixinLanguages],
  components: {
    LeftMenu,
    TopHeader,
    CKEditorForm
  },
  data () {
    return {
      isLoading: false,
      isUpdated: false,
      webInfos: {},
      webInfoIDs: ['content-of-page-terms-of-service-Tw', 'content-of-page-terms-of-service-En', 'content-of-page-terms-of-service-Jp'],
      activeLang: 'Tw'
    }
  },
  computed: {
  },
  methods: {
    onInput () {
      this.isUpdated = true
    },
    submit () {
      var promiseList = []
      var payloads = []
      for (let obj of this.$store.state.webInfo.list) {
        if (!this.webInfoIDs.includes(obj.ID)) continue

        this.webInfos[obj.ID].Value = this.$refs['form-' + (obj.ID.split('-')[obj.ID.split('-').length - 1])].getHTML()
        if (this.webInfos[obj.ID].Value === obj.Value) continue

        let payload = {
          ID: obj.ID,
          Value: this.webInfos[obj.ID].Value
        }
        payloads.push(payload)
        let promise = this.$services.webInfo.edit(this, payload)
        promiseList.push(promise)
      }

      if (promiseList.length === 0) {
        return alert('錯誤: 並未更動')
      }
      this.isLoading = true
      Promise.all(promiseList)
        .then(results => {
          let okCount = 0
          let errCount = 0

          for (var i = 0; i < results.length; i++) {
            let res = results[i]
            let ok = res && res.data && res.data.status === 'ok'
            okCount += ok ? 1 : 0
            errCount += !ok ? 1 : 0

            if (ok) {
              let payload = payloads[i]
              let idx = this.$store.state.webInfo.list.findIndex(o => o.ID === payload.ID)
              if (idx < 0) console.error('更新異常，找不到 webInfo，idx null')
              this.$store.state.webInfo.list[idx].Value = payload.Value
              this.$set(this.webInfos[payload.ID], 'Value', payload.Value)
            }
          }

          if (errCount === 0) {
            this.$message({
              message: `更新成功`,
              type: 'success'
            })
          } else if (okCount === 0) {
            console.error(results)
            this.$message.error(`更新異常!`)
          } else {
            this.$message({
              message: `${okCount}筆資料更新成功, ${errCount}筆資料更新異常`,
              type: 'warning'
            })
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    loadData () {
      for (let obj of this.$store.state.webInfo.list) {
        if (this.webInfoIDs.includes(obj.ID)) {
          this.$set(this.webInfos, obj.ID, JSON.parse(JSON.stringify(obj)))
        }
      }
    }
  },
  created () {
    this.loadData()
  }
}
</script>
